import { render, staticRenderFns } from "./MasterPassword.vue?vue&type=template&id=61c5da70&"
import script from "./MasterPassword.vue?vue&type=script&lang=ts&"
export * from "./MasterPassword.vue?vue&type=script&lang=ts&"
import style0 from "./MasterPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports